<template>
  <el-container class="app-main">
    <el-row class="about-main">
      <h1>{{ msg }}</h1>
    </el-row>
  </el-container>
</template>

<script>
  export default {
    name: "About",
    data() {
      return {
        msg: 'Welcome to About!'
      }
    },
    methods: {}
  }
</script>

<style scoped lang="less">
  .app-main {
    .about-main {
      width: 100%;
      height: auto;
      min-height: calc(100vh - 160px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/About.vue